/* eslint-disable class-methods-use-this */
import * as api from '../../../../utils/apiClient';

class DataService {
  async getReferenceLists() {
    const response = await api.get('/data/lists');
    const data = await response.json();
    return data;
  }

  async getReferenceListsNew() {
    const response = await api.get('/data/reference-data');
    const data = await response.json();
    return data;
  }

  async getCounts() {
    const response = await api.get('/data/counts');
    const data = await response.json();
    return data;
  }
}

export default new DataService();



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/main/services/DataService/DataService.js